import { render, staticRenderFns } from "./ExpertPurchase.vue?vue&type=template&id=2cddd82c&scoped=true&"
import script from "./ExpertPurchase.vue?vue&type=script&lang=js&"
export * from "./ExpertPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ExpertPurchase.vue?vue&type=style&index=0&id=2cddd82c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cddd82c",
  null
  
)

export default component.exports